var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.46875 2.75H0.6875C0.308 2.75 0 3.058 0 3.4375C0 3.817 0.308 4.125 0.6875 4.125H2.0625V14.4375C2.0625 16.3357 3.60181 17.875 5.5 17.875H11C12.8982 17.875 14.4375 16.3357 14.4375 14.4375V4.125H15.8125C16.192 4.125 16.5 3.817 16.5 3.4375C16.5 3.058 16.192 2.75 15.8125 2.75H12.0312V2.0625C12.0312 1.51525 11.814 0.990686 11.4269 0.604311C11.0406 0.217248 10.516 0 9.96875 0C8.94575 0 7.55425 0 6.53125 0C5.984 0 5.45944 0.217248 5.07306 0.604311C4.686 0.990686 4.46875 1.51525 4.46875 2.0625V2.75ZM13.0625 4.125V14.4375C13.0625 15.5767 12.1392 16.5 11 16.5H5.5C4.36081 16.5 3.4375 15.5767 3.4375 14.4375V4.125H13.0625ZM10.6562 2.0625V2.75H5.84375V2.0625C5.84375 1.88031 5.91594 1.705 6.04519 1.57644C6.17375 1.44719 6.34906 1.375 6.53125 1.375H9.96875C10.1509 1.375 10.3263 1.44719 10.4548 1.57644C10.5841 1.705 10.6562 1.88031 10.6562 2.0625Z",
    fill: "#2B2D42"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 6.875V13.75C5.5 14.1295 5.808 14.4375 6.1875 14.4375C6.567 14.4375 6.875 14.1295 6.875 13.75V6.875C6.875 6.4955 6.567 6.1875 6.1875 6.1875C5.808 6.1875 5.5 6.4955 5.5 6.875ZM9.625 6.875V13.75C9.625 14.1295 9.933 14.4375 10.3125 14.4375C10.692 14.4375 11 14.1295 11 13.75V6.875C11 6.4955 10.692 6.1875 10.3125 6.1875C9.933 6.1875 9.625 6.4955 9.625 6.875Z",
    fill: "#EE243A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.274692f39e9f7c0ce069dad668ca76b7.svg";
export { ForwardRef as ReactComponent };